import React, { useEffect } from "react";
import { Button } from "../components/button/button";
import { Header } from "../components/header/header";
import { Search } from "../components/search/search";
import newDcCinza from "../img/newDcCinza.svg";
import person from "../img/person.svg";
import addRackCount from '../img/new_window.svg';
import "../styles/addDc.css";
import { useNavigate } from "react-router-dom";
import { useStore } from '../store/useStore'
import Chip from "../components/chip/chip";

function SelectDcs() {
    const navigate = useNavigate();
    const { siteData } = useStore()
    const [initialData, setInitialData] = React.useState(siteData)
    const [localVar, setLocalVar] = React.useState(siteData);

    useEffect(() => {
        setInitialData(siteData)
        setLocalVar(siteData)
    }, [siteData])

    let items = [
        {
            title: "Data Center",
            img: newDcCinza,
            route: '/'
        },
        {
            title: "Clients",
            img: person,
            route: '/client'
        },
        {
            title: "Add Rack Count",
            img: addRackCount,
            route: '/select/dc'
        },
    ];

    return (
        <section className="control-body">
            <Header line>
                <Chip
                    onClick={navigate}
                    items={items}
                    quantity={3}
                    active={2}
                    style={{ width: "875px" }}
                />
            </Header>
            <div className="search-area">
                <Search
                    initialData={initialData}
                    set={setLocalVar}
                    style={{
                        border: "1px solid #0F0742",
                        boxShadow: "0 0 0",
                        width: "100%",
                    }}
                    placeholder="Search Data Center"
                />
            </div>
            <section className="content-add-racks-button-selected">
                {
                    localVar.map(val => {
                        return (
                            <div className="add-racks-button-selected">
                                <h1>{val.site}</h1>
                                <h3>Total Racks {val.totalRacks}</h3>
                                <h3>{val.rooms.length} Rooms</h3>
                                <Button onClick={()=> navigate(`/site/${val.site}/${val.id}`)} label='Add Racks'/>
                            </div>
                        )
                    })
                }
            </section>

        </section >
    );
}

export default SelectDcs;
